module.exports = __webpack_public_path__ + "static/media/hand-holding-heart-solid.6b2b7f41.svg";